import { combineReducers } from "redux";
import { authReducer } from "./auth";
import NomineeReducer, { NomineeReducerState } from "./nominees";
import { dashboard } from "./dashboard";
import portfolio from "./portfolio";
import { investor } from "./investors";
import { transactions } from "./transactions";
import { profileReducer } from "./profile";
import { transactionHistory } from "./history";
import { support } from "./support";
import { loading } from "./loader";
import { npsReducer } from "./nps";
import { newinvestor } from "./newinvestor";
import { lamfReducer } from "./lamf";
import { newSubscriber } from "./newSubscriber";
import { loaderUtil } from "./loaderUtil";
import { cartReducer } from "./cart";
import popup from "./toast";

export interface RootStateType {
  authReducer: any;
  dashboard: any;
  investor: any;
  transactions: any;
  profileReducer: any;
  transactionHistory: any;
  support: any;
  loading: any;
  npsReducer: any;
  newinvestor: any;
  lamfReducer: any;
  NomineeReducer: NomineeReducerState;
  //integrating 2 more reducers from MFcentral
  //authReducer
  portfolio: any;
  cartReducer: any;
  popup: typeof popup;
}

const rootReducer = combineReducers({
  authReducer,
  dashboard,
  investor,
  transactions,
  profileReducer,
  transactionHistory,
  support,
  loading,
  npsReducer,
  newinvestor,
  lamfReducer,
  newSubscriber,
  loaderUtil,
  NomineeReducer,
  portfolio,
  cartReducer,
  popup,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
